import { useContext } from "react";
import { ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import {formatShortDate} from "../../../../utils/date-utils";

export default function PlumbingBanner() {

	const { order } = useContext(RetailOrderContext);

	if (!order.details.plumbingRetailOrderID || order.details.roTypeID !== ROType.Retail) {
		return <></>;
	}

	return (
		<div className="plumbing-banner">
			<div className="icon-wrapper">
				<i className="dx-icon dx-icon-Inscyth-Plumbing" />
			</div>
			<span>Note: this order contains plumbing.</span>
			{order.details.plumbingScheduledDisconnectDate && <span> Scheduled Disconnect Date: {formatShortDate(order.details.plumbingScheduledDisconnectDate)}.</span>}
			{order.details.plumbingScheduledReconnectDate && <span> Scheduled Reconnect Date: {formatShortDate(order.details.plumbingScheduledReconnectDate)}.</span>}
		</div>

	);
}